import React from 'react';
import { Button, ButtonProps } from '@material-ui/core';


export default (props: ButtonProps) => <Button {...props} variant="outlined" />
